export const translationLivechat_en_availability = {
  livechatChangeAvailability: "Availability:",
  livechatGoOnline: "Go online",
  livechatGoOffline: "Go offline",
  livechatUseSchedule: "Use schedule",
  livechatAvailabilityDisabledHelp: "Chatbots disabled by an administrator stay unchanged.",
  livechatAvailabilityUpdated: "Availability updated for {count} chatbots in {scope}.",
  livechatAvailabilityUpdatedOne: "Availability updated for {chatbot}.",
  livechatAvailabilityAllOnline: "All online",
  livechatAvailabilityAllOffline: "All offline",
  livechatAvailabilityMixed: "Mixed · {online} of {total} online",
  livechatAvailabilityUnknown: "Availability unavailable",
};
